module.exports = new __parcel__URL__("ui-dev-panel-magnified-with-bitbucket-logo.20a3f9ce.svg").toString();